import { MatchCustomValue, Profile, SkillsFramework } from "PFCore/types";

export const getProfileFrameworkSkills = (skillsFramework: SkillsFramework, profile: Profile) =>
  skillsFramework.skills.map(({ skillId, value, requiredExperience, tagIds }) => {
    const profileSkill = profile.skills?.find(({ id }) => id === skillId);

    return {
      ...profileSkill,
      id: skillId,
      value,
      requiredExperience,
      state: "approved",
      tagIds
    } as MatchCustomValue;
  });
